<template>
  <MountingTimeslotRegistrations
    :model-value="modelValue"
    variant="pending"
  />
</template>

<script lang="tsx" setup>
import MountingTimeslotRegistrations
  from "@pages/mountings/mounting/timeslots/MountingTimeslotRegistrations.vue";
import {MountingTimeslot} from "@/entities/Entities";

interface Props {
  modelValue: MountingTimeslot;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
</style>
